export enum EAntIconUrl {
  ARROW_DOWN_OUTLINED = 'arrow_down_outlined',
  ARROW_RIGHT_OUTLINED = 'arrow_right_outlined',
  ARROW_LEFT_OUTLINED = 'arrow_left_outlined',
  ARROW_UP_OUTLINED = 'arrow_up_outlined',

  AUDIT_OUTLINED = 'audit_outlined',

  BARS_OUTLINED = 'bars_outlined',

  BELL_OUTLINED = 'bell_outlined',

  CLOSE_CIRCLE_OUTLINED = 'close_circle_outlined',
  CLOSE_OUTLINED = 'close_outlined',

  COMMENT_OUTLINED = 'comment_outlined',

  COPY_OUTLINED = 'copy_outlined',

  PLUS_CIRCLE_OUTLINED = 'plus_circle_outlined',
  PLUS_OUTLINED = 'plus_outlined',

  EDIT_OUTLINED = 'edit_outlined',
  EDIT_FILLED = 'edit_filled',

  FILE_OUTLINED = 'file_outlined',
  FILE_PDF_OUTLINED = 'file_pdf_outlined',

  FILTER_OUTLINED = 'filter_outlined',

  LOADING_OUTLINED = 'loading_outlined',

  LOGOUT_OUTLINED = 'logout_outlined',

  MENU_OUTLINED = 'menu_outlined',

  DELETE_OUTLINED = 'delete_outlined',

  UPLOAD_OUTLINED = 'upload_outlined',
  USER_OUTLINED = 'user_outlined',

  EXPAND_ALT_OUTLINED = 'expand_alt_outlined',
}
